module.exports = __webpack_public_path__ + "img/48.d180acb1.svg";